module.exports = __webpack_public_path__ + "img/pnewyear.396e8280.png";